import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { authApi } from "../../hooks/authApi";
import { User } from "../../types/User";
import { AuthContext } from "./AuthContext";

export const AuthProvider = ({ children }: { children: JSX.Element }) => {
  const [user, setUser] = useState<User | null | false>(null);
  const [loading, setLoading] = useState(false);
  const [permissoesUsuario, setPermissoesUsuario] = useState<number[]>([]);
  const [customizadas, setCustomizadas] = useState<boolean>(false);
  const [permissoesPlanos, setPermissoesPlanos] = useState<any>([]);
  const location = useLocation();
  const api = authApi();

  const getPermissoesUsuario = async () => {
    const data = await api.getPermissoes();
    setPermissoesUsuario(data);
  };

  const getCustomizado = async () => {
    const data = await api.getCustomizado();
    setCustomizadas(data);
  };

  const getPermissoesPlanos = async () => {
    const data = await api.getPermissoesPlanos();
    setPermissoesPlanos(data);
  };

  const validateToken = async () => {
    const data = await api.validateToken();
    if (data === "erro") {
      setUser(false);
      return false;
    } else {
      setUser(data);
      return true;
    }
  };

  const signin = async (email: string, password: string, forcarLogin: boolean = false) => {
    const data = await api.signin(email, password, forcarLogin);
    if (data === "LOGADO") {
      return "LOGADO";
    } else {
      const erro = data.response?.data?.error;

      if (erro === "SESSAO_ATIVA_OUTRO_DISPOSITIVO" || erro === "2FA_REQUERIDO") {
        return data.response.data;
      }
      return data.response.data.error;
    }
  };

  const verificar2FA = async (desafio: string, codigo: string) => {
    const data = await api.verificar2FA(desafio, codigo);
    if (data === "LOGADO") {
      return "LOGADO";
    }
    return data?.response?.data?.error ?? "ERRO_INESPERADO";
  };

  const signout = async () => {
    const data = await api.logout();
    if (data == "DESLOGADO") {
      setUser(false);
      setToken("");
    }

    return false;
  };

  const setToken = (token: string) => {
    localStorage.setItem("token", token);
  };

  useEffect(() => {
    const init = async () => {
      setLoading(true);
      await validateToken();
      await getPermissoesUsuario();
      await getCustomizado();
      await getPermissoesPlanos();
      setLoading(false);
    };
    init();
  }, [location.pathname]);

  return (
    <AuthContext.Provider
      value={{
        user,
        signin,
        verificar2FA,
        signout,
        validateToken,
        permissoesUsuario,
        customizadas,
        loading,
        permissoesPlanos,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
